import React, { memo, useState, useEffect, useCallback } from 'react';
import _ from 'lodash';
import styles from '../styles/components/Slider.scss';
import classNames from 'classnames';

const RangeSlider = memo(({ value, onChange, disabled, color }) => {
  const [sliderVal, setSliderVal] = useState(value);

  const debouncedUpdate = useCallback(
    _.debounce((newValue) => {
      onChange(newValue);
    }, 500),
    []
  );

  useEffect(() => {
    setSliderVal(value);
  }, [value]);

  const handleChange = (e) => {
    const newValue = Number(e.target.value);
    setSliderVal(newValue);
    debouncedUpdate(newValue);
  };

  // const getSliderBackground = () => {
  //   return `linear-gradient(to right, #029DFC ${sliderVal}%, #ccc ${sliderVal}%)`;
  // };

  // const normalizedValue = Math.min(sliderVal, 100);

  const getSliderBackground = () => {
    const normalized = Math.min(sliderVal, 100);

    // DEFAULT (blue)
    if (!color) {
      return `linear-gradient(
        to right,
        #3D81F8 ${normalized}%,
        #E0E0E0 ${normalized}%
      )`;
    }

    // RED (over limit)
    if (color === 'red') {
      const overPercent = Math.min(sliderVal - 100, 100);
      const lightRedPercent = 100 - overPercent;

      if (overPercent >= 100) {
        return `linear-gradient(
          to right,
          #FF0000 0%,
          #FF0000 100%
        )`;
      }

      return `linear-gradient(
        to right,
        #F5B7B1 0%,
        #F5B7B1 ${lightRedPercent}%,
        #FF0000 ${lightRedPercent}%,
        #FF0000 100%
      )`;
    }

    // BLUE
    if (color === 'blue') {
      return `linear-gradient(
        to right,
        #3D81F8 ${normalized}%,
        #E0E0E0 ${normalized}%
      )`;
    }

    // GREEN
    if (color === 'green') {
      return `linear-gradient(
        to right,
        #88A722 ${normalized}%,
        #E0E0E0 ${normalized}%
      )`;
    }

    // YELLOW
    if (color === 'yellow') {
      return `linear-gradient(
        to right,
        #FE9800 ${normalized}%,
        #E0E0E0 ${normalized}%
      )`;
    }

    // GRAY
    if (color === 'gray') {
      return `linear-gradient(
        to right,
        rgb(174, 173, 170) ${normalized}%,
        #E0E0E0 ${normalized}%
      )`;
    }

    // fallback
    return `linear-gradient(
      to right,
      #029DFC ${normalized}%,
      #E0E0E0 ${normalized}%
    )`;
  };

  return (
    <div className={styles.rangeSlider}>
      <input
        type='range'
        value={sliderVal}
        min='0'
        style={{
          background: getSliderBackground(),
        }}
        max='100'
        disabled={disabled}
        step='1'
        className={classNames(
          styles.rangeSliderInput,
          disabled && styles.disabled
        )}
        onChange={handleChange}
      />
    </div>
  );
});

export default RangeSlider;
